module.exports = __webpack_public_path__ + "static/media/signInLogo.92a73f18.svg";